import { render, staticRenderFns } from "./HighlightsCardSection.vue?vue&type=template&id=a8a2ba04&scoped=true"
import script from "./HighlightsCardSection.vue?vue&type=script&lang=ts"
export * from "./HighlightsCardSection.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsCardSection.vue?vue&type=style&index=0&id=a8a2ba04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a2ba04",
  null
  
)

export default component.exports